import React,{Component} from 'react';
import {connect} from "react-redux";
import "./style.less";
import {NavBar,Modal,Toast,Button} from "antd-mobile";
import {checkPay,dismissAddress} from "../../../service/shiftService";
const goshiyong = require('../../../common/image/goshiyong.png');
let timerInterval
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class TwoDimensionalCode extends Component{
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            showModal:false,
            downTime:'',
            image:'',
            amount:'',
            addresschangeId:'',
            amount:'',
            addressChangeAfter:'',
            addressChangeBefore:'',
            payFlag:0,
            flag:true
        };
    }

    componentWillMount(){
        if(this.props.location && this.props.location.data){
            let img = this.props.location.data.image.replace("http", "https");
            this.setState({
                image:img,
                amount:this.props.location.data.amount,
                addresschangeId:this.props.location.data.addresschangeId,
                addressChangeAfter:this.props.location.data.addressChangeAfter,
                addressChangeBefore:this.props.location.data.addressChangeBefore
            });
        }
    }

    componentDidMount() {
        if(this.props.location.data && this.props.location.data.timeArea){
            var downTime = (this.props.location.data.timeArea/1000).toFixed(0);
        }
        this.setDownTime(downTime);
        this.Interval();
        
    }
    //支付时间为10分钟，应该为获取到用户价格时开始计时，倒计时结束，二维码失效，提示用户支付超时，取消该订单，跳转到修改地址页面，重新选择
    setDownTime = (time) => {
        let timer = setInterval(() => {
            if (time > 0) {
                time--;
               setTimeout(() => {
                    let minutes = Math.floor(time / 60);
                    let seconds = Math.floor(time % 60);
                    this.setState({downTime:  minutes + "分" + seconds + "秒"});
                }, 1000);
            } else {
                this.setState({downTime: 0,payFlag:1,flag:false});
                clearInterval(timer);
                clearInterval(timerInterval);
                let params = {
                    token: this.props.userInfo.token,
                    "data": {
                        "addresschangeId":this.state.addresschangeId,
                    }
                }
                dismissAddress(params).then((res) => {
                    if (res.data.code === '0000') {//当倒计时为0 时，自动取消订单
                            // Toast.info('支付超时，请重新修改地址！',2,this.props.history.push('./passengerInfo',{seatId:this.props.history.location.seatId}))
                            Toast.info('支付超时，请重新修改地址！')
                    }
                    else if (res.data.code === '1401') {
                        document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                    }
                })
            }
        }, 1000);
    };
    Interval = () => {
        timerInterval = setInterval(() => {
            let params = {
                token: this.props.userInfo.token,
                "data": {
                    "addressOfrecordId":this.state.addresschangeId,
                }
            }
            checkPay(params).then((res) => {
                if (res.data.code === '0000') {//返回成功，应该跳转到修改地址页面,并将地址传回去,停止请求
                    if(!res.data.data){
                        // Toast.info('支付成功！地址修改成功！',2,this.props.history.push('./passengerInfo',{seatId:this.props.history.location.seatId}))
                        Toast.info('支付成功！地址修改成功！',2,this.props.history.goBack(-1))
                        clearInterval(timerInterval)
                    }
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }else{
                    if(this.state.flag == false){
                        clearInterval(timerInterval)
                    }
                   
                    
                }
            })
        }, 5000);
    }
    delete=()=>{
        //点击取消修改，需要返回到修改地址页，清除定时请求接口的定时器
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "addresschangeId":this.state.addresschangeId,
            }
        }
        dismissAddress(params).then((res) => {
            this.setState({flag:false});
            if (res.data.code === '0000') {//当倒计时为0 时，自动取消订单
                // Toast.info('取消成功，如需修改请重新进入地图选址！',2,this.props.history.push('./passengerInfo',{seatId:this.props.history.location.seatId}))
                Toast.info('取消成功，如需修改请重新进入地图选址！',2,this.props.history.goBack(-1))
                clearInterval(timerInterval)
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else{
                // Toast.info(res.data.msg);
            }
        })
    }
    Wxpay = () =>{
        document.location = `js://wxReplacePay?orderId=${this.state.addresschangeId}&token=${this.props.userInfo.token}`;
    }
    render(){
        return(
            <div className="twoDimensionalCode">
                <NavBar
                    className="navBar"
                    mode="light"
                    // icon={<i className="icon iconfont iconmorenfanhui"  onClick={() => this.props.history.push('./passengerInfo',{seatId:this.props.history.location.seatId})}/>}
                    icon={<i className="icon iconfont iconmorenfanhui"  onClick={() => {
                        this.props.history.goBack(-1)
                        clearInterval(timerInterval)
                    }}/>}
                >支付</NavBar>
                <div className="content">
                    <div className="bgwhite"><span>微信扫码支付</span></div>
                    <p></p>
                    <div className="pay"><i className="icon iconfont iconshuomingtishi"/>请在<span>{this.state.downTime}</span>完成支付！</div>
{/*                     {this.state.payFlag == 0 ? <div className="img"><img src={this.state.image}/></div>:<div className="dismiss">二维码已失效，请重新修改地址</div>}

        */ }                <div className="img"><img src={this.state.image}/></div>   
                    {this.state.payFlag == 0 ? <div className="amount">待支付：<span>￥{this.state.amount}</span></div> : null}
                </div>
                <div className="address">
                    <div>修改信息：</div>
                    <div>原地址 <span>{this.state.addressChangeBefore}</span></div>
                    <div>新地址 <span>{this.state.addressChangeAfter}</span></div>
                    <div className="tips">提  示：地址修改所产生的差价退款时不退回！</div>
                </div>
                <Button className="cancel"  onClick={()=>this.setState({showModal:true})}>取消修改</Button>
                <div className="Wxpay" onClick={()=>this.Wxpay()}>代乘客支付</div>
                <Modal
                    className="combineBillViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '不取消', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '取消修改', onPress: () => { this.setState({showModal:!this.state.showModal});this.delete() } }]}
                    >
                    <div className="modalTitle">
                        <div>是否确认取消修改？</div>
                        <div>点击取消修改后要修改地址需重选地址</div>
                    </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/TwoDimensionalCode/index.js